import {
  GETTER_BILLS_STATE,
  GETTER_UNSETTLED_BILLS,
  GETTER_SETTLED_BILLS,
  ACTION_SET_BILLS_STATE,
  MUTATE_BILLS_STATE,
  ACTION_CLEAR_BILLS_MODULE,
  MUTATE_CLEAR_BILLS_MODULE,
} from './types';

import {
  updateStateProps,
  mutateStateProps,
} from './common-functions';

const defaultState = () => ({
  fetching: false,
  unsettledBills: [],
  settledBills: [],
  initialized: false,
});

const state = defaultState();

const getters = {
  [GETTER_BILLS_STATE]: (state) => state,
  [GETTER_UNSETTLED_BILLS]: ({unsettledBills}) => unsettledBills,
  [GETTER_SETTLED_BILLS]: ({settledBills}) => settledBills,
};

const actions = {
  [ACTION_SET_BILLS_STATE]: updateStateProps(MUTATE_BILLS_STATE),
  [ACTION_CLEAR_BILLS_MODULE]: ({commit}) => {
    commit(MUTATE_CLEAR_BILLS_MODULE);
  },
};

const mutations = {
  [MUTATE_BILLS_STATE]: mutateStateProps,
  [MUTATE_CLEAR_BILLS_MODULE]: (state) => {
    Object.assign(state, defaultState());
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
